import { render, staticRenderFns } from "./addBranchStore.vue?vue&type=template&id=1220c67b"
import script from "./addBranchStore.vue?vue&type=script&lang=js"
export * from "./addBranchStore.vue?vue&type=script&lang=js"
import style0 from "./addBranchStore.vue?vue&type=style&index=0&id=1220c67b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports